import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgJiraBugIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 14,
	viewBox: "0 0 16 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 1.5C7.17157 1.5 6.5 2.17157 6.5 3H9.5C9.5 2.17157 8.82843 1.5 8 1.5ZM11 3.02074V3C11 1.34315 9.65685 0 8 0C6.34315 0 5 1.34315 5 3V3.02074C4.70952 3.06947 4.44734 3.2017 4.239 3.39189L3.35231 2.75855L2.43536 0.695396L1.06464 1.3046L2.00928 3.43004C2.0999 3.63393 2.24344 3.80985 2.425 3.93953L3.75 4.88596V6H0.5V7.5H3.75V8.64872L2.60021 9.60688C2.46773 9.71728 2.35953 9.85389 2.28241 10.0081L1.07918 12.4146L2.42082 13.0854L3.60066 10.7257L4.06124 10.3419C4.69682 11.9183 6.23827 13 8.00146 13H8.25C9.96908 13 11.4349 11.9156 12.0006 10.3934L12.3993 10.7257L13.5792 13.0854L14.9208 12.4146L13.7176 10.0081C13.6405 9.85389 13.5323 9.71728 13.3998 9.60688L12.25 8.64872V7.5H15.5V6H12.25V4.88596L13.575 3.93953C13.7566 3.80985 13.9001 3.63393 13.9907 3.43004L14.9354 1.3046L13.5646 0.695396L12.6477 2.75855L11.761 3.39189C11.5527 3.2017 11.2905 3.06947 11 3.02074ZM10.75 9V4.5H5.25V8.94265L5.28488 9.1694C5.49117 10.5102 6.64486 11.5 8.00146 11.5H8.25C9.63071 11.5 10.75 10.3807 10.75 9Z"
	})
});
export default SvgJiraBugIcon;
